import apiClient from '@/services/axios'

export async function get(reportId, workspaceId) {
  var response = await apiClient.get(`/PowerBI?reportId=${reportId}&workspaceId=${workspaceId}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get report details')
}
